<template>
  <div class="baseUpload">
    <ul class="upload-list-picture-card">
      <li class="upload-list-item" v-for="(item, index) in list" :key="index">
        <div class="img-content">
          <img :src="item.url" alt=""/>
          <div @click="handleRemoveItem(index, list)" class="closeSpan">
            <i class="el-icon-close"/>
          </div>
          <div class="img-mark" @click="handlePreview(index)"><i class="el-icon-zoom-in"/></div>
        </div>
      </li>
      <li class="upload-list-item">
        <div class="upload-right" v-show="!isView && list.length < limit">
          <el-upload
            ref="upload"
            :headers="heard"
            :action="uploadUrl"
            :limit="limit"
            :data="uploadData"
            :before-upload="handleBeforeUpload"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :on-error="handleError"
            :on-exceed="handleExceed"
            :on-change="handleChange"
            :auto-upload="false"
            :disabled="disabled"
            accept=".png,.jpg,.jpeg"
            :list-type="listType"
            :show-file-list="false">
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
          <div class="img-upload-title">{{ $lang('上传图片') }}</div>
        </div>
      </li>
    </ul>
    <el-dialog :title="$lang('查看图片')"
               :visible.sync="isShowDialog"
               @close="isShowDialog = false"
               :close-on-click-modal="false"
               :modal-append-to-body="false"
               :append-to-body="true"
               width="600px">
      <el-carousel :initial-index="preIndex" :autoplay="false">
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <img :src="item.url" style="width: 100%; height: 100%; object-fit: contain;">
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import { IMG_URL, RESPONSE_SUCCESS } from '@/constants'
import { fetchOSS } from '@/api/module/customer'

export default {
  name: 'TheUploadImage',
  props: {
    // 单图是否显示预览
    isPreView: {
      type: Boolean,
      default: function () {
        return true
      },
    },
    size: {
      type: Array,
    },
    uploadUrl: {
      type: String,
      default: function () {
        return IMG_URL
      },
    },
    // 上传组件自定义标识，同一页面有多个文件时使用
    uploadKey: {
      type: String,
      default: function () {
        return ''
      },
    },
    // 文件列表显示类型
    listType: {
      type: String,
      default: function () {
        return 'picture-card'
      },
    },
    // 文件列表
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    fileTypeList: {
      type: Array,
      default: function () {
        return ['png', 'jpg', 'jpeg']
      },
    },
    // 是否禁用图片上传
    disabled: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    // 最大允许上传个数
    limit: {
      type: Number,
      default: function () {
        return 3
      },
    },
    // 是否在选取文件后立即进行上传
    auto: {
      type: Boolean,
      default: function () {
        return true
      },
    },
    // 上传图片参数(必须传的)
    uploadData: {
      type: Object,
      default: function () {
        return {}
      },
    },
    isView: {
      type: Boolean,
      default: function () {
        return false
      },
    },
  },
  data() {
    return {
      heard: {},
      fileListLength: 0,
      errorUploadImg: '/assets/images/error_upload.png',
      isShowDialog: false,
      preIndex: 0, // 预览时de索引
      elMessage: null, // elMessage实列
    }
  },
  created() {
    this.heard = {
      authToken: this.$store.state.base.token,
      routeName: this.$route.name,
    }
  },
  methods: {
    async handleSuccess(res, file, fileList) {
      console.log('上传成功', res.data)
      if (res.code === RESPONSE_SUCCESS) {
        const oss = await fetchOSS([res.data])
        this.elMessage.close()
        if (oss.code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang('上传成功'))
          this.$emit('uploadSuccess', {
            res: {
              path: res.data,
              url: oss.data[0]
            },
            file: oss.data,
            fileList: fileList,
            key: this.uploadKey,
          })
        } else {
          this.$message.error(oss.msg)
        }
      } else {
        fileList.splice(fileList.length - 1, 1) // 上传失败，要将失败的图片清除
        this.$message.error(res.msg)
      }
    },
    handleError(err, file, fileList) {
      file.isError = true
      this.$message.error(this.$lang('图片上传失败，请重试'))
      this.$emit('uploadError', { res: err, file: file, fileList: fileList, key: this.uploadKey })
    },
    handleRemoveItem(index, fileList) {
      this.$emit('uploadRemove', index, fileList, this.uploadKey)
      this.$refs.upload.handleRemove()
    },
    handleRemove(file, fileList) {
    },
    handleExceed() {
      this.$message.warning(`${this.$lang('本次上传最多')} ${this.limit}${this.$lang('张图片')}`)
    },
    handleBeforeUpload(file) {
      this.elMessage = this.$message.info({
        message: this.$lang('正在上传,请稍等'),
        duration: 0
      })
    },
    handleChange(file, fileList) {
      const $this = this
      this.$emit('uploadChange', file, fileList, this.uploadKey)
      const type = file.raw.type.split('/')[1]
      const isRtTy = !this.fileTypeList.length || this.fileTypeList.includes(type)
      // 压缩图片
      this.compress(file.raw, function (data) {
        fileList.reduce((pre, cur) => {
          if (cur.name === data.name) {
            data.uid = cur.raw.uid
            cur.raw = data
          }
        }, [])
      })
      $this.$refs.upload.submit()
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isRtTy) {
        //  符号需要中英切换，直接用空格
        const errStr = this.$lang('只能上传') + this.fileTypeList.join(' ') + this.$lang('格式')
        return this.$message.error(this.$lang(errStr))
      }
      if (!isLt5M) {
        return this.$message.error(this.$lang('上传头像图片大小不能超过5MB!'))
      }
    },
    compress(fileObj, callback) {
      try {
        const $this = this
        const image = new Image()
        image.src = URL.createObjectURL(fileObj)
        image.onload = function () {
          // 默认按比例压缩
          let w = this.width
          let h = this.height
          const scale = w / h
          w = fileObj.width || w
          h = fileObj.height || w / scale
          let quality = 0.92 // 默认图片质量为0.92
          // 生成canvas
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          // 创建属性节点
          const anw = document.createAttribute('width')
          anw.nodeValue = w
          const anh = document.createAttribute('height')
          anh.nodeValue = h
          canvas.setAttributeNode(anw)
          canvas.setAttributeNode(anh)
          ctx.drawImage(this, 0, 0, w, h)
          // 图像质量
          if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
            quality = fileObj.quality
          }
          // quality值越小，所绘制出的图像越模糊
          const data = canvas.toDataURL('image/jpeg', quality)
          // 压缩完成执行回调
          const newFile = $this.dataURLtoFile(data, fileObj.name)
          callback(newFile)
        }
      } catch (e) {
        console.log('压缩失败!')
      }
    },
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    /**
     * 处理图片预览
     */
    handlePreview(index) {
      this.isShowDialog = true
      this.preIndex = index
    },
  },
}
</script>

<style lang="scss" scoped>
.baseUpload {
  overflow: hidden;
  display: inline-flex;

  .upload-list-picture-card {
    overflow: hidden;
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: row wrap;

    .upload-list-item {
      margin-right: 20px;
      margin-bottom: 20px;
      list-style: none;
      border: none;
      outline: none;

      .img-content {
        width: 100px;
        height: 100px;
        border-radius: 6px;
        border: 1px solid #ddd;
        position: relative;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .img-mark {
          position: absolute;
          left: -1px;
          display: none;
          width: calc(100% + 2px);
          height: 28px;
          text-align: center;
          color: #fff;
          font-size: 20px;
          background-color: rgba(0, 0, 0, 0.5);
          transition: all 0.3s;
          cursor: pointer;
          bottom: 1px;

          i {
            color: #fff;
            font-size: 18px;
            cursor: pointer;
          }
        }
      }

      .img-content:hover {
        .img-mark {
          display: block;
          bottom: 0;
        }

        .closeSpan {
          position: absolute;
          top: 0;
          right: 0;
          background: #0000008c;
          color: #FFF;
          width: 20px;
          height: 20px;
          line-height: 20px;
          border-radius: 0 0 0 4px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

  // 上传图片
  .upload-right {
    float: left;
    position: relative;

    ::v-deep {
      .el-upload {
        height: 100px;
        width: 100px;
        border: 1px solid #ddd;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .img-upload-title {
      font-size: 12px;
      color: #999999;
      text-align: center;
      line-height: 28px;
    }
  }

  .el-dialog__header {
    border-bottom: 0 solid #dddddd;
  }

  .el-dialog__body {
    text-align: center;
  }

  .el-dialog__body > img {
    width: 50%;
  }

  .el-upload--picture-card {
    line-height: 100px;
  }
}
</style>
